"use strict";

var React           = require("react");
var Router          = require("react-router");
var Link = Router.Link;

var Information = React.createClass({
    render: function() {
        return (
            <section className="information">
                <div>
                    <div className="startNow">
                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <h2 className="section-heading">Fullkomin Búnaðarskrá. Allt á hreinu </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className=" col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-4 text-center">
                                <p className="text-muted">Búnaðarbankinn er hin fullkomna búnaðarskrá. Vertu með á hreinu hvað þú átt og hvar það er geymt. Seldu hluti sem þú notar ekki lengur og haltu utan um verðmætin sem leynast í litlu hversdagslegu hlutunum.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="startNowLink">
                                <Link to="frontpage">
                                    <span className="startNowLink-text">Byrja núna</span>
                                    <span className="glyphicon glyphicon-arrow-right"></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="moreDetails">
                        <div className="row">
                            <div className="col-md-10 col-md-offset-2 col-xs-11 col-xs-offset-1">
                                <h2 className="section-heading">1.200 ánægðir viðskiptavinir </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-md-offset-2 col-sm-6 col-xs-10 col-xs-offset-1">
                                <p>Búnaðarbankinn þjónustar nú yfir 1.200 stofnanir og fyrirtæki sem öll eiga það sameiginlegt að vilja hafa það á hreinu þegar kemur að búnaði og lausafjármunum.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-10 col-sm-5 col-md-4 col-lg-3 col-xs-offset-1 col-md-offset-2">
                                <div className="moreDetailsLink">
                                    <Link to="frontpage">
                                        <span className="moreDetailsLink-text">Skoða nánar</span>
                                        <span className="glyphicon glyphicon-arrow-right"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="subscriptions">
                        <div className="row">
                            <div className="col-sm-4 col-sm-offset-4 col-xs-8 col-xs-offset-2 text-center">
                                <h2>Engin uppsetning </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2 text-center">
                                <h1>Byrjaðu Strax </h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2 text-center">
                                <p>Það tekur enga stund að byrja að nota Búnaðarbankann. Þú einfaldlega velur þér áskriftarleið og byrjar að skrá búnaðinn þinn. </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="free">
                                <div className="col-xs-12">
                                    <h2> Frítt </h2>
                                </div>
                                <div className="col-xs-12">
                                    <ul>
                                        <li>- lorem ipsum </li>
                                        <li>- snilld </li>
                                        <li>- flott </li>
                                        <li>- geggjað </li>
                                        <li>- 500kr. á mánuði á notanda </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="pro">
                                <div className="col-xs-12">
                                    <h2> Pro </h2>
                                </div>
                                <div className="col-xs-12">
                                    <p>Allt það sama og í Frítt plús </p>
                                </div>
                                <div className="col-xs-12">
                                    <ul>
                                        <li>+ lorem ipsum </li>
                                        <li>+ cool </li>
                                        <li>+ nett </li>
                                        <li>+ geggjað </li>
                                        <li>+ 1000kr. á mánuði á notanda </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="enterprise">
                                <div className="col-xs-12">
                                    <h2> Enterprise </h2>
                                </div>
                                <div className="col-xs-12">
                                    <p>Allt það sama og í Pro plús </p>
                                </div>
                                <div className="col-xs-12">
                                    <ul>
                                        <li>+ lorem ipsum </li>
                                        <li>+ fallegt </li>
                                        <li>+ ótrúlegt </li>
                                        <li>+ stórfenglegt </li>
                                        <li>+ 2000kr. á notanda </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="updateSubscription">
                        <div className="col-lg-3 col-lg-offset-5 col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2">
                            <p>ATH. Að þú getur uppfært áskrifarleiðina þína hvenær sem er. </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
});

module.exports = Information;



// WEBPACK FOOTER //
// ./app/scripts/ui/Frontpage/Information.react.js